import React from 'react';
import {useTranslation} from 'react-i18next';
import Modal from '../../../../incase-domain/components/modals/directory/Modal';
import Button from '../../../../incase-domain/components/button/Button';
import {IPresentationFolder} from './types';

export function MoveToFolderModal({
    open,
    folders,
    moving,
    onClose,
    onSelect,
}: {
    open: boolean;
    folders: IPresentationFolder[];
    moving: boolean;
    onClose: () => void;
    onSelect: (folderId: string | null) => void;
}): JSX.Element {
    const {t} = useTranslation();
    return (
        <Modal
            isOpen={open}
            header={t('editorPage.folders.moveToFolder')}
            icon="solar:folder-move-linear"
            onCancel={onClose}
            dataCy="move-to-folder-modal"
        >
            <div className="c-folderNav__moveList">
                <Button variant="ghost" fullWidth align="left" leading="solar:file-linear" onClick={() => onSelect(null)} disabled={moving}>
                    {t('editorPage.folders.unfiled')}
                </Button>
                {folders.map((folder) => (
                    <Button
                        key={folder._id}
                        variant="ghost"
                        fullWidth
                        align="left"
                        leading="solar:folder-linear"
                        onClick={() => onSelect(folder._id)}
                        disabled={moving}
                    >
                        {`${folder.name} (${folder.presentationCount})`}
                    </Button>
                ))}
            </div>
        </Modal>
    );
}
